export enum COACH_COMMUNITY_TYPE_ENUM {
	COACH_USER_ONE_ON_ONE = "COACH_USER_ONE_ON_ONE",
	COACH_USER_GROUP = "COACH_USER_GROUP",
}

export interface IFetchCoachCommunityParams {
	coachId: number
	communityType: COACH_COMMUNITY_TYPE_ENUM
	searchTerm?: string
	onlyUnreadCount?: number
}

export interface IChatMediaInfo {
	s3Key: string
	name: string
	sizeInBytes?: number
	extension?: string
}

export interface IChatMetadata {}

export interface IChatLastMessage {
	id: number
	createdOn: number
	lastModifiedOn: number
	createdBy: string
	version: number
	userId: number
	userType: string
	communityId: number
	body: string
	mediaInfo: IChatMediaInfo
	messageTime: number
	metadata: IChatLastMessage
	broadcast: boolean
	reactionCount: number
}

export interface ICommunityChatEntry {
	id: number
	createdOn: any
	lastModifiedOn: any
	createdBy: string
	version: number
	name: string
	adminId: number
	adminType: string
	communityType: string
	isGroupCommunity: boolean
}

export interface IChatUsersInfo {
	userId: number
	name: string
	phoneNumber: string
	profilePicture: string
	userType: string
}

export interface Metadata {}

export interface ICommunityMessageReportEntry {
	id: number
	createdOn: any
	lastModifiedOn: any
	createdBy: string
	version: number
	messageId: number
	userId: number
	userType: string
	status: string
	occurredAt: any
}

export interface ICommunityMessageReaction {
	id: number
	createdOn: any
	lastModifiedOn: any
	createdBy: string
	version: number
	messageId: number
	userId: number
	userType: string
	reaction: string
}

export interface ICommunityMessage {
	id: number
	createdOn: any
	lastModifiedOn: any
	createdBy: string
	version: number
	userId: number
	userType: string
	communityId: number
	body: string
	messageTime: any
	metadata: Metadata
	broadcast: boolean
	reactionCount: number
	messageReportEntries?: ICommunityMessageReportEntry[]
	messageReactions: ICommunityMessageReaction[]
	deletedOn?: number
	deletedBy: string
	parentMessageId?: number
	parentMessage: ICommunityMessage
	mediaInfo: IChatMediaInfo
	mediaType: string
}

export interface IChatConversationSummary {
	unreadCount: number
	lastMessage: ICommunityMessage
	communityEntry: ICommunityChatEntry
	usersInfo: IChatUsersInfo[]
	doctorId?: number
}
export interface IFetchCoachCommunityResponse {
	totalUnreadCount: number
	conversationSummaries: IChatConversationSummary[]
}
